import React from 'react';
import classNames from 'classnames';

import config from '../../config';
import LogoImage from './logo.svg';
import css from './Logo.css';

const Logo = props => {
  const { className, format = 'desktop', ...rest } = props;
  const mobileClasses = classNames(css.logoMobile, className);

  if (format === 'desktop') {
    return <img className={className} src={LogoImage} alt={config.siteTitle} {...rest} />;
  }

  return <img className={mobileClasses} src={LogoImage} alt={config.siteTitle} {...rest} />;
};

export default Logo;
